export interface BookingExpenseInvoiceTagLookup {
  id: number;
  name: string;
}

export interface BookingExpenseInvoiceTagShape {
  id: number;
  name?: string | null;
}

export const mapTagToBookingExpenseInvoiceLookup = (
  tag: BookingExpenseInvoiceTagShape | undefined | null
): BookingExpenseInvoiceTagLookup | undefined => {
  if (!tag) {
    return undefined;
  }

  const normalizedName = tag.name?.trim();
  if (!normalizedName) {
    return undefined;
  }

  return {
    id: tag.id,
    name: normalizedName,
  };
};

